import * as React from "react"
import type { SVGProps } from "react"
const SvgTextUnderline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6 21.29a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7q0-.43.29-.72A1 1 0 0 1 6 19.3h12q.42 0 .71.28.3.3.29.72c-.01.42-.1.52-.29.7a1 1 0 0 1-.71.3zm6-4q-2.53 0-3.92-1.58a6 6 0 0 1-1.4-4.17V4.56q0-.52.38-.9a1.3 1.3 0 0 1 .91-.38q.52 0 .9.38c.38.38.38.55.38.9v7.13q0 1.4.7 2.27t2.05.87 2.05-.87.7-2.28V4.56q0-.52.39-.9a1.3 1.3 0 0 1 .91-.38q.52 0 .9.38c.38.38.37.55.37.9v6.98q0 2.6-1.4 4.17A5 5 0 0 1 12 17.29" />
  </svg>
)
export default SvgTextUnderline
